'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import * as CustomPropTypes from '../../../constants/PropTypes';
import styled from 'styled-components';
import { CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { MICRO_TRANSITION_TIMING } from 'HubStyleTokens/times';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import AppCard from 'ecosystem-marketplace-core/components/cards/AppCard';
import { getIsNewOffering } from 'ecosystem-marketplace-core/utils/offerings';
import { getListingDetailUrl } from '../../../utils/urls';
import ThinListing from 'ecosystem-marketplace-core/records/ThinListing';
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "ResultCard__StyledRouterLink",
  componentId: "sc-144qz1h-0"
})(["display:flex;align-items:stretch;"]);
const StyledAppCard = styled(AppCard).withConfig({
  displayName: "ResultCard__StyledAppCard",
  componentId: "sc-144qz1h-1"
})(["&&{border:2px solid transparent;transition:border ", " ease-out;&:hover{border-color:", ";}}"], MICRO_TRANSITION_TIMING, CALYPSO_MEDIUM);

const ResultCard = ({
  isAdminPreview,
  onClick,
  result,
  superCategory
}) => {
  const {
    category,
    companyName,
    firstPublishedAt,
    iconUrl,
    installed,
    installsCount,
    name,
    slug,
    tagline
  } = result;
  const showIsNewApp = getIsNewOffering(firstPublishedAt); // Disable click effects while maintaining style

  return /*#__PURE__*/_jsx(StyledRouterLink, {
    onClick: isAdminPreview ? undefined : onClick,
    to: isAdminPreview ? '#' : getListingDetailUrl(slug, category, superCategory),
    use: "unstyled",
    children: /*#__PURE__*/_jsx(StyledAppCard, {
      category: category,
      companyName: companyName,
      className: "m-bottom-0",
      iconUrl: iconUrl,
      installed: installed,
      installsCount: installsCount,
      name: name,
      showIsNewApp: showIsNewApp,
      slug: slug,
      tagline: tagline
    })
  });
};

ResultCard.propTypes = {
  isAdminPreview: PropTypes.bool,
  onClick: PropTypes.func,
  result: PropTypes.instanceOf(ThinListing).isRequired,
  superCategory: CustomPropTypes.superCategory
};
export default ResultCard;